module.exports = __webpack_public_path__ + "img/1482424692.6d29ac8b.jpg";